<template>
  <section
    class="header app-bar"
    v-if="$route.name !== 'landing'"
  >
    <div class="container-fluid">
      <nav class="app-bar">
        <div class="row align-items-center">
          <div
            class="col"
            @click="goHome"
          >
            <img
              :src="logo"
              alt="Borderplex"
              class="header-logo"
            >
          </div>
          <div class="col text-center">
            <router-link
              :to="{name: 'home', params: {ciudad: 'juarez'}}"
              href="#"
            >
              <span :class="$route.params.ciudad === 'juarez'?'texto-juarez mr-2 ml-2':'texto-ciudad mr-2 ml-2'">Cd Juárez</span>
            </router-link>
            <router-link
              :to="{name: 'home', params: {ciudad: 'el-paso'}}"
              href="#"
            >
              <span :class="$route.params.ciudad === 'el-paso'?'texto-el-paso mr-2 ml-2':'texto-ciudad mr-2 ml-2'">EL Paso</span>
            </router-link>
            <router-link
              :to="{name: 'home', params: {ciudad: 'las-cruces'}}"
              href="#"
            >
              <span :class="$route.params.ciudad === 'las-cruces'?'texto-las-cruces mr-2 ml-2':'texto-ciudad mr-2 ml-2'">Las Cruces</span>
            </router-link>
          </div>
          <div class="col">
            <div class="float-right">
              <!-- <router-link
                :to="{name: 'landing'}"
                tag="a"
              >
                <span class="texto-informativo pa-2 mr-2 ml-2">Ayuda al visitante</span>
              </router-link> -->
              <router-link
                :to="{name: 'ayuda'}"
                tag="a"
              >
                <span :class="$route.name==='ayuda'?'texto-informativo-rounded pa-2 mr-2 ml-2':'texto-informativo pa-2 mr-2 ml-2'">¿Qué es BPX?</span>
              </router-link>
              <router-link
                :to="{name: 'vision'}"
                tag="a"
              >
                <span :class="$route.name==='vision'?'texto-informativo-rounded pa-2 mr-2 ml-2':'texto-informativo pa-2 mr-2 ml-2'">Visión BPX</span>
              </router-link>
              <a href="https://admin.bpx.social">
                <span
                  class="texto-informativo pa-2 mr-2 ml-2"
                  style="cursor:pointer;"
                >Accesso a clientes</span>
              </a>
            </div>
          </div>
        </div>
      </nav>
    </div>
  </section>
</template>

<script lang="js">
import axios from 'axios'
import logo from '../assets/V2/logo-borderplex.jpg'
import menu from '../assets/menu.png'
export default {
  name: 'navbar',
  props: [],
  mounted () {
    // this.getBridges()
  },
  data () {
    return {
      logo,
      menu,
      bridges: {},
      selected: false
    }
  },
  methods: {
    goHome () {
      this.$router.push({ name: 'home', params: { ciudad: 'juarez' } })
    },
    getBridges () {
      axios.get('https://alpuente.mx/widget/juarez/').then(res => {
        this.bridges = res.data.crossings
      }, err => {
        console.log(err)
      }, this)
    }
  },
  computed: {

  }
}
</script>

<style scoped lang="scss">
.header {
  background: white;
  border-bottom: 2px solid black;
  &-logo {
    height: 10vh;
    width: auto;
    cursor: pointer;
  }
  .navbar {
    .cambio {
      color: aliceblue;
      text-align: center;
      .col-sm-4:first-of-type {
        border-right: 1px solid #ed5a24;
      }
    }
    .bridges {
      // margin-top: 0.7em;
      td {
        text-align: left;
        border: 0;
        &:nth-child(2n) {
          padding: 0 0 0 55px;
          border: 0;
          border-left: 1px solid #ed5a24;
        }
      }
    }
    .menu {
      height: 36px;
      width: auto;
    }
  }
  .app-bar {
    height: 10vh;
    a {
      text-decoration: none;
    }
  }
}
.texto-ciudad {
  font-size: 1.5vw;
  color: black;
  font-weight: bold;
}
.texto-juarez {
  font-size: 1.5vw;
  font-weight: bold;
  color: black;
  border: 1px solid #6f0f49;
  border-radius: 20px;
  border-width: 3px;
  padding: 5px;
  padding-left: 10px;
  padding-right: 10px;
}
.texto-el-paso {
  font-size: 1.5vw;
  font-weight: bold;
  color: black;
  border: 1px solid #166073;
  border-radius: 20px;
  border-width: 3px;
  padding: 5px;
  padding-left: 10px;
  padding-right: 10px;
}
.texto-las-cruces {
  font-size: 1.5vw;
  font-weight: bold;
  color: black;
  border: 1px solid #ee6225;
  border-radius: 20px;
  border-width: 3px;
  padding: 5px;
  padding-left: 10px;
  padding-right: 10px;
}
.texto-informativo {
  font-size: 1vw;
  color: #580c48;
}

.texto-informativo-rounded {
  border: 1px solid #6f0f49;
  border-radius: 20px;
  border-width: 3px;
  padding: 5px;
  padding-left: 10px;
  padding-right: 10px;
}
</style>
